import React, { useState, useEffect } from 'react';
import './MoUCard.css';
import { ethers } from 'ethers';
import MoUContractABI from '../../contracts/MoUContract.json';

const MOU_CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;

function MoUCard({ account, onViewMoUDetails }) {
  const [initiatorName, setInitiatorName] = useState('');
  const [counterpartyName, setCounterpartyName] = useState('');
  const [counterpartyAddress, setCounterpartyAddress] = useState('');
  const [mous, setMous] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (account) {
      fetchMoUs();
    }
  }, [account]);

  const fetchMoUs = async () => {
    if (!account) return;
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
      const contract = new ethers.Contract(contractAddress, MoUContractABI.abi, signer);
      const userMoUs = await contract.getUserMoUs(account);
      console.log('Fetched user MoUs:', userMoUs);
      
      // Create a mutable copy of the array and sort it
      const sortedMoUs = [...userMoUs].sort((a, b) => b.toNumber() - a.toNumber());
      console.log('Sorted MoUs:', sortedMoUs);
      setMous(sortedMoUs);
    } catch (error) {
      console.error('Error fetching MoUs:', error);
      setError('Failed to fetch MoUs. Please try again.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!account) {
      setError('Please connect your wallet first.');
      return;
    }
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
      const contract = new ethers.Contract(contractAddress, MoUContractABI.abi, signer);
      console.log('Creating MoU with params:', counterpartyAddress, initiatorName, counterpartyName);
      const tx = await contract.createMoU(counterpartyAddress, initiatorName, counterpartyName);
      await tx.wait();
      console.log('MoU created successfully');
      setInitiatorName('');
      setCounterpartyName('');
      setCounterpartyAddress('');
      fetchMoUs(); // Refresh the MoU list
    } catch (error) {
      console.error('Error creating MoU:', error);
      setError('Failed to create MoU. Please try again.');
    }
  };

  return (
    <div className="mou-card">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/>
        </svg>
        MoUs
      </h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Initiator Name"
          value={initiatorName}
          onChange={(e) => setInitiatorName(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Counterparty Name"
          value={counterpartyName}
          onChange={(e) => setCounterpartyName(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="Counterparty Address"
          value={counterpartyAddress}
          onChange={(e) => setCounterpartyAddress(e.target.value)}
          required
        />
        <button type="submit" className="create-mou-button">Create MoU</button>
      </form>
      {mous.length > 0 ? (
        <button 
          className="view-mou-button"
          onClick={() => {
            const latestMouId = ethers.BigNumber.isBigNumber(mous[0]) ? mous[0].toNumber() : mous[0];
            console.log('Viewing latest MoU:', latestMouId);
            onViewMoUDetails(latestMouId);
          }}  
        >
          View Latest MoU ({ethers.BigNumber.isBigNumber(mous[0]) ? mous[0].toNumber() : mous[0]})
        </button>
      ) : (
        <p className="no-mous-message">No MoUs found for this account.</p>
      )}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
}

export default MoUCard;